/**
 * Entscheidet, was eine Dialog-Anfrage des Chats öffnet.
 *
 * Recruiting-Kampagnen werden nicht mehr im alten Anlage-Fenster angelegt, sondern im
 * geführten Wizard „Neue Kampagne“. Der Chat schickt dafür entweder die Karte
 * `campaign_wizard` oder (ältere Karten im Verlauf) `create_campaign` mit Typ Recruiting.
 * Sales, ein offener Typ und „Kampagne kopieren“ (`mode: 'clone'`) bleiben beim bisherigen Fenster.
 */

import { toWizardPrefill, WizardPrefill } from '../../co-pilot/campaign-wizard/wizard-prefill';
import { clonesInWizard } from '../../co-pilot/campaign-overview/wizard-routing';

interface DialogRequestLike {
  dialog: string;
  props?: Record<string, unknown>;
}

export const startsRecruitingWizard = (request: DialogRequestLike | null | undefined): boolean => {
  if (!request) return false;
  if (request.dialog === 'campaign_wizard') return true;
  // „Kampagne kopieren“ (mode 'clone') behält das alte Klon-Fenster: der leere Wizard würde die Kopier-Absicht verlieren.
  return (
    request.dialog === 'create_campaign' &&
    request.props?.campaignType === 'recruiting' &&
    request.props?.mode !== 'clone'
  );
};

/** Was der Chat schon weiß (Name, Konto, Anzeige) – ohne personenbezogene Daten in der URL. */
export const wizardPrefillOf = (request: DialogRequestLike): WizardPrefill | null =>
  toWizardPrefill(request.props);

/**
 * Karte „Im Kampagnen-Assistenten öffnen“ (Schreib-Werkzeuge sind für Wizard-Entwürfe gesperrt):
 * `campaignId` in den Props öffnet genau diese Kampagne im Assistenten statt einer neuen.
 */
export const wizardCampaignIdOf = (request: DialogRequestLike | null | undefined): string | null => {
  if (!request || request.dialog !== 'campaign_wizard') return null;
  const id = request.props?.campaignId;
  return typeof id === 'string' && id.trim() !== '' ? id.trim() : null;
};

/**
 * „Kampagne kopieren“ im Chat-Fenster: Ist die gewählte Vorlage eine Recruiting-Wizard-Kampagne, läuft der Klon
 * über den Klonpfad des Assistenten (bereinigter Suchstand, eigene Blacklists, Bewertung der Kontakte) und
 * der Nutzer landet im Assistenten, nicht im alten Builder.
 */
export const clonesWizardCampaign = (source: { type?: string; wizard?: unknown } | null | undefined): boolean =>
  clonesInWizard(source?.type === 'active_sourcing_co_pilot', source);
